"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMappedObservable = void 0;

var react_1 = require("react");

var operators_1 = require("rxjs/operators");

var observable_1 = require("./observable");
/**
 * Create a memoized observable with a map implemented and a distinctUntilChanged,
 * the observable will be unsubscribe automatically if component unmount
 * @returns [observableValue, error, isCompleted]
 */


function useMappedObservable(observableGenerator, mapperFunction, deps, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }

  var mapper = react_1.useCallback(mapperFunction, deps);
  var newGenerator = react_1.useCallback(function () {
    return observableGenerator().pipe(operators_1.filter(function (value) {
      return !!value;
    }), operators_1.map(mapper), operators_1.distinctUntilChanged(function (a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }));
  }, [observableGenerator, mapper]);
  return observable_1.useObservable(newGenerator, deps, defaultValue);
}

exports.useMappedObservable = useMappedObservable;